// Imports
var ___CSS_LOADER_API_IMPORT___ = require("C:\\Users\\Vision\\AppData\\Roaming\\nvm\\v16.13.1\\node_modules\\expo-cli\\node_modules\\css-loader\\dist\\runtime\\api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("C:\\Users\\Vision\\AppData\\Roaming\\nvm\\v16.13.1\\node_modules\\expo-cli\\node_modules\\css-loader\\dist\\runtime\\getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./img/team-shape.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".team .member .member-img:after {\r\n  position: absolute;\r\n  content: \"\";\r\n  left: 0;\r\n  bottom: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat center bottom;\r\n  background-size: contain;\r\n  z-index: 1;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
